<template>
  <div>
    <Loader v-if="loading" />
    <PageHeader title="مدیریت انتقال صفحات" :items="pageHeaderItems" />
    <div class="card">
      <div class="title">انتقال صفحه</div>
      <div class="sections">
        <b-row v-for="(url, index) in items" :key="index" class="rows">
          <b-col cols="12" md="6">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="url.fromUrl" @input="url.fromUrl = $event" title="از" placeholder="از" />
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="url.toUrl" @input="url.toUrl = $event" title="به" placeholder="به" @focused="addModel" />
            </div>
          </b-col>
          <div v-if="url.fromUrl && url.toUrl && url.id" class="del" @click="deleteRow(url.id)">
            <img src="../../assets/images/dadbanan/del.svg" />
          </div>
        </b-row>
        <div class="action">
          <b-button @click="$router.go(-1)">انصراف</b-button>
          <b-button variant="primary ms-2 px-5" @click="addUrl">ثبت</b-button>
        </div>
      </div>
    </div>
    <Toast :title="message" :error="error" :showToast="showToast" />
  </div>
</template>

<script>
import PageHeader from '../layoutComponents/page-header.vue'
import BaseText from '../common/form/formModules/BaseText.vue'
import dadbanRedirectProvider from '../../services/dadban/redirect.js'
import Toast from '../common/Toast.vue'
import Loader from '../widgets/loader.vue'

export default {
  components: { PageHeader, BaseText, Toast, Loader },
  data() {
    return {
      model: {
        fromUrl: '',
        toUrl: '',
      },
      items: [],
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت انتقال صفحات', active: true },
      ],
      showToast: false,
      message: 'بروزرسانی با موفقیت انجام شد',
      error: false,
      loading: false,
    }
  },
  mounted() {
    this.fetchRedirects()
  },
  methods: {
    async fetchRedirects() {
      const req = await dadbanRedirectProvider.getAllRedirects()
      this.items = req.data.data.output
      this.items.push({
        fromUrl: '',
        toUrl: '',
      })
    },
    async addUrl() {
      this.loading = true
      let isEmpty = false
      const lastItem = this.items.length - 1
      if (!this.items[lastItem].toUrl && !this.items[lastItem].fromUrl) {
        this.items.splice(lastItem, 1)
      } else if ((!this.items[lastItem].toUrl && this.items[lastItem].fromUrl) || (this.items[lastItem].toUrl && !this.items[lastItem].fromUrl)) {
        this.loading = false
        this.error = true
        this.message = 'لطفا لینک مبدا و مقصد را به درستی وارد کنید'
        this.showToast = true
        isEmpty = true
        setTimeout(() => {
          this.error = false
          this.message = 'بروزرسانی با موفقیت انجام شد'
          this.showToast = false
          isEmpty = false
        }, 5000)
      }
      if (!isEmpty) {
        const req = await dadbanRedirectProvider.addRedirect(this.items)
        this.items.push({ fromUrl: '', toUrl: '' })
        this.loading = false
        if (req.status === 200) {
          this.showToast = true
          this.fetchRedirects()
        }

        setTimeout(() => {
          this.showToast = false
        }, 5000)
      }
    },
    async deleteRow(id) {
      await dadbanRedirectProvider.deleteRedirect(id)
      await this.fetchRedirects()
    },
    addModel() {
      const lastItem = this.items.length - 1
      if (this.items[lastItem].fromUrl) {
        this.items.push({ fromUrl: '', toUrl: '' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 14px;
  margin: 24px;
}

.sections {
  background: #f8f9fa;
  padding: 1rem 1rem 1rem 4rem;
  border-radius: 6px;
  margin: 24px 20px;
  position: relative;
}

img {
  height: 20px;
  width: 20px;
  z-index: 1;
}

.del {
  position: absolute;
  left: -35px;
  top: 22px;
  width: auto;
  cursor: pointer;
}

.rows {
  position: relative !important;
}

.action {
  position: relative;
  display: flex;
  justify-content: left;
  left: -40px;
  margin-top: 50px;
}
</style>
